import { useClusters } from "../../Pages/K8s/hooks";

export const useIsCustomerUsingKubernetesUtilization = () => {
  const [clusters] = useClusters();

  return {
    isCustomerUsingKubernetesUtilization: clusters?.some((cluster) => cluster?.perfectScale?.TenantID) || false,
  };
};
